import React, { Component } from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import DuplicateTrailModal from "../../../../components/DuplicateTrailModal";
import Loading from "../../../../components/Loading";
import TrailModal from "../../../../components/Modal/trailModal";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import Statistics from "../../../../components/Statistics/StatisticsTrail/statistics";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

// eslint-disable-next-line import/newline-after-import
const FileDownload = require("js-file-download");
class TrailList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      loading: true,
      trailModal: false,
      selectedTrail: null,
      duplicationID: null,
      showDuplicationModal: false
      // file: null
    };

    this.error = this.error.bind(this);
    this.insertAction = this.insertAction.bind(this);
    this.deleteAction = this.deleteAction.bind(this);
    this.printAction = this.printAction.bind(this);
  }

  error = response => {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  };

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    this.handleTrails();
  }

  handleTrails() {
    this.setState({ loading: true });

    axios
      .get(`${URL.api}activity/trail/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({
          list: resp.data.data,
          loading: false
        });
      });
  }

  insertAction = () => {
    this.setState({ trailModal: true, selectedTrail: null });
  };

  duplicateAction = row => {
    this.setState({ duplicationID: row.id, showDuplicationModal: true });
  };

  editAction = row => {
    this.props.history.push(`/trail/edit/${row.id}`);
  };

  deleteAction = arrayRow => {
    for (const row of arrayRow) {
      axios
        .post(
          `${URL.api}activity/trail/delete/${row}`,
          {},
          {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          }
        )
        .then(resp => {
          this.handleTrails();
        })
        .catch(err => {
          this.error("Não foi possível apagar a trilha");
        });
    }
  };

  allocateAction = row => {
    this.props.history.push(`/trail/allocate/${row.id}`);
  };

  reportAction = row => {
    this.setState({ statisticsModal: true, selectedTrail: row.id });
  };

  deepDuplicate() {
    axios
      .post(
        `${URL.api}activity/trail/deep_duplicate/${this.state.duplicationID}`,
        {},
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }
      )
      .then(
        resp => {
          if (resp.data.success) {
            this.props.history.push(`/trail/edit/${resp.data.data}`);
            this.componentDidMount();
          } else {
            toastr.error("Falha", "Não foi possível duplicar a trilha");
          }
        },
        () => {
          toastr.error("Falha", "Não foi possível duplicar a trilha");
        }
      );
  }

  duplicate() {
    axios
      .post(
        `${URL.api}activity/trail/duplicate/${this.state.duplicationID}`,
        {},
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }
      )
      .then(
        resp => {
          if (resp.data.success) {
            this.props.history.push(`/trail/edit/${resp.data.data}`);
            this.componentDidMount();
          } else {
            toastr.error("Falha", "Não foi possível duplicar a trilha");
          }
        },
        () => {
          toastr.error("Falha", "Não foi possível duplicar a trilha");
        }
      );
  }

  printAction = row => {
    // Mock do createObjectURL para testes
    if (process.env.NODE_ENV === "test") {
      window.URL.createObjectURL = jest.fn();

      // Resetar o mock após cada teste
      afterEach(() => {
        window.URL.createObjectURL.mockReset();
      });
    }

    const downloadPath = row.file
      ? row.file.substring(row.file.indexOf("uploads/") + 8)
      : `activity/${row.file.split("/").reverse()[0]}`;

    axios
      .get(`${URL.api}download/${downloadPath}`, {
        headers: { authorization: `Bearer ${this.props.user.token}` },
        responseType: "blob"
      })
      .then(resp => {
        const fileURL =
          window.URL.createObjectURL || window.webkitURL.createObjectURL;

        if (!fileURL) {
          return;
        }

        const fileBlob = new Blob([resp.data], { type: "application/pdf" }); // ajuste o tipo MIME conforme necessário

        // Abrir o conteúdo em uma nova janela
        const printWindow = window.open(fileURL(fileBlob), "_blank");

        if (printWindow) {
          // Aguarde até que a janela seja carregada e, em seguida, imprima
          printWindow.onload = () => {
            printWindow.print();
          };
        }
      });
  };

  render() {
    return (
      <>
        <DuplicateTrailModal
          id={this.state.duplicationID}
          show={this.state.showDuplicationModal}
          onClose={() => this.setState({ showDuplicationModal: false })}
          onDuplicate={() => this.duplicate()}
          onDeepDuplicate={() => this.deepDuplicate()}
        />
        {this.state.statisticsModal && (
          <Statistics
            show
            onClose={() => this.setState({ statisticsModal: false })}
            trailId={this.state.selectedTrail}
            trailName={
              this.state.list.find(item => item.id === this.state.selectedTrail)
                ?.name
            }
            currentRoute={this.props.currentRoute}
          />
        )}
        {this.state.trailModal && (
          <TrailModal
            show
            onClose={shouldLoad =>
              this.setState({ trailModal: false }, () =>
                shouldLoad ? this.handleTrails() : null
              )
            }
            trailId={this.state.selectedTrail}
            history={this.props.history}
          />
        )}
        <div className="animated fadeIn">
          <Row>
            <Breadcrumb current={this.props.currentRoute} />
            {this.state.loading ? (
              <Loading top="45" left="50" />
            ) : (
              <>
                {this.state.list ? (
                  <div id="list">
                    <DataTable
                      list={this.state.list}
                      path="/trail/show/"
                      title="Trilhas"
                      header={[
                        { name: "id", denomination: "ID" },
                        { name: "name", denomination: "Nome" },
                        { name: "description", denomination: "Descrição" }
                      ]}
                      insert
                      delete
                      insertAction={this.insertAction}
                      action
                      btnView
                      btnEdit
                      btnAllocate
                      btnReport
                      btnPrint
                      btnDuplication
                      printAction={this.printAction}
                      editAction={this.editAction}
                      duplicateAction={this.duplicateAction}
                      allocateAction={this.allocateAction}
                      reportAction={this.reportAction}
                      deleteAction={this.deleteAction}
                    />
                  </div>
                ) : (
                  <Loading />
                )}
              </>
            )}
          </Row>
        </div>
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(TrailList);
